import { useEffect } from 'react';
import { TextInput, useInputHelper } from 'framework/form';
import { getProbationReduction } from '../finance/getProbationReduction';

type ProbationPeriodReductionInputProps = {
  source: string;
  probationAmountSource: string;
  baseAmountSource: string;
  saveToContext?: boolean;
  [key: string]: any;
};

const ProbationPeriodReductionInput = ({
  probationAmountSource,
  baseAmountSource,
  source,
  saveToContext = false,
  ...props
}: ProbationPeriodReductionInputProps) => {
  const { getValue: getProbationAmountValue } = useInputHelper({ source: probationAmountSource });
  const { getValue: getBaseAmountValue } = useInputHelper({ source: baseAmountSource });
  const { getRawOnChangeCallback } = useInputHelper({ source });

  const changeCallback = getRawOnChangeCallback()!;
  const probationAmountValue = getProbationAmountValue();
  const baseAmountValue = getBaseAmountValue();

  const getFieldValue = () => {
    if (!baseAmountValue || !probationAmountValue) {
      return '';
    }

    return getProbationReduction(probationAmountValue, baseAmountValue);
  };

  useEffect(() => {
    if (saveToContext) {
      changeCallback({
        [source]: getFieldValue(),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveToContext, probationAmountValue, baseAmountValue]);

  return <TextInput value={getFieldValue() as string} source={source} disabled {...props} />;
};

export default ProbationPeriodReductionInput;
